import PropTypes from 'prop-types'

import {useMemo, useState} from 'react'
import {connect} from 'react-redux'
import {updateResource} from 'redux-json-api'

import {Stack, Typography} from '@mui/material'

import Button from '../../../../shared_components/mui_base_components/button/Button'
import ButtonGroup from '../../../../shared_components/mui_base_components/button/ButtonGroup'
import ItemPermissionsSelectForm from '../../../../shared_components/item_permissions/ItemPermissionsSelectForm'

import {requestedItemPermissions} from '../../../../lib/itemPermissionTools'

import image from '../../../../shared_assets/quarterbackImage.png'

import './quarterbackInviteAndDeputySetupInterstitialController.scss'

export const QuarterbackInviteAndDeputySetupInterstitialController = props => {
  const {
    quarterback_request_item_permissions_invite: quarterbackRequestItemPermissionsInvite
  } = props.interstitials?.quarterback_invite_and_deputy_setup[0] || {}

  const permittedItemIds = useMemo(() => (
    quarterbackRequestItemPermissionsInvite?.item_permissions ?
      Object.keys(quarterbackRequestItemPermissionsInvite.item_permissions) :
      []
  ), [quarterbackRequestItemPermissionsInvite])

  const [checkedItemIds, setCheckedItemIds] = useState(permittedItemIds)
  const [processingAccept, setProcessingAccept] = useState(false)
  const [processingDecline, setProcessingDecline] = useState(false)

  const submitItemPermissions = itemIds => {
    const payload = {
      type: 'quarterback-request-item-permissions-invites',
      id: quarterbackRequestItemPermissionsInvite.id,
      attributes: {
        'accepted-item-permissions': requestedItemPermissions({
          itemIds,
          permissionType: 'edit'
        }),
        status: itemIds.length ? 'accepted' : 'declined'
      }
    }

    props.updateResource(payload).then(props.returnToController)
  }

  const handleDeclinePermission = () => {
    setProcessingDecline(true)
    setCheckedItemIds([])

    submitItemPermissions([])
  }

  const handleGrantPermission = () => {
    setProcessingAccept(true)

    submitItemPermissions(checkedItemIds)
  }

  return (
    <div className='quarterback-invite-and-deputy-setup-interstitial-controller'>
      <Typography variant='h1' className='heading'>
        Everplans Concierge
      </Typography>
      <div className='img-description-container'>
        <Stack direction='column'>
          <Typography variant='h3' className='subheading'>
            What is Everplans Concierge?
          </Typography>
          <Typography variant='body1' className='description'>
            Included with your subscription, a member of our Concierge Team will help you get started, stay on track, and build a plan that reflects your life. Your one-on-one phone session is completely private.
          </Typography>
        </Stack>
        <img alt='' src={image} />
      </div>
      <Typography variant='h3' className='subheading'>
        In order to help you with your Everplan, your Concierge would like the following permission:
      </Typography>
      {
        quarterbackRequestItemPermissionsInvite &&
        <>
          <ul>
            <li className='permission'>View, edit, add, remove, and download the content of the following sections of your Everplan</li>
          </ul>
          <ItemPermissionsSelectForm
            checkedItemIds={checkedItemIds}
            onCheck={checkedItems => setCheckedItemIds(checkedItems)}
            permittedItemIds={permittedItemIds}
          />
        </>
      }
      <Typography variant='body1' className='acknowledgement'>
        I understand I can revoke this authorization at any time in my account settings.
      </Typography>
      <ButtonGroup>
        <Button
          color='cancel'
          disabled={processingAccept}
          loading={processingDecline}
          onClick={handleDeclinePermission}>
          No, thanks
        </Button>
        <Button
          disabled={processingDecline}
          loading={processingAccept}
          onClick={handleGrantPermission}>
          Grant permission
        </Button>
      </ButtonGroup>
    </div>
  )
}

QuarterbackInviteAndDeputySetupInterstitialController.propTypes = {
  interstitials: PropTypes.shape({
    quarterback_invite_and_deputy_setup: PropTypes.arrayOf(
      PropTypes.shape({
        quarterback_request_item_permissions_invite: PropTypes.shape({
          id: PropTypes.string.isRequired,
          item_permissions: PropTypes.object.isRequired
        })
      })
    )
  }).isRequired,
  returnToController: PropTypes.func.isRequired,
  updateResource: PropTypes.func.isRequired
}

export default connect(null, {updateResource})(QuarterbackInviteAndDeputySetupInterstitialController)
